<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMessageContext } from './provider.js';

const { t } = useI18n();
const { contentAttributes } = useMessageContext();

const reactions = computed(() => contentAttributes.value?.reactions ?? []);

const groupedReactions = computed(() => {
  const groups = new Map();

  reactions.value.forEach(({ emoji, type, name }) => {
    const group = groups.get(emoji) ?? {
      emoji,
      count: 0,
      names: [],
      hasAgent: false,
    };

    group.count += 1;
    if (name) group.names.push(name);
    if (type === 'agent') group.hasAgent = true;

    groups.set(emoji, group);
  });

  return [...groups.values()];
});

const reactedBy = group =>
  group.names.join(', ') || t('CONVERSATION.CUSTOMER_REACTION');
</script>

<template>
  <div v-if="groupedReactions.length" class="flex flex-wrap gap-1 mt-1">
    <span
      v-for="group in groupedReactions"
      :key="group.emoji"
      class="inline-flex items-center px-1.5 py-0.5 text-xs rounded-full cursor-default"
      :class="group.hasAgent ? 'bg-n-blue-3' : 'bg-n-alpha-2'"
      :title="reactedBy(group)"
    >
      <span class="text-sm">{{ group.emoji }}</span>
      <span v-if="group.count > 1" class="ms-1 text-n-slate-11">
        {{ group.count }}
      </span>
    </span>
  </div>
</template>
